// extracted by mini-css-extract-plugin
module.exports = {"header":"Awatn","img":"C8nT7","textbox":"j4_Ev","btn":"IlyCe","content":"M_EUm","text":"__3P1F_"};